import createDataContext from './createDataContext';
import { api } from '../api/api';

const productSelectorsReducer = (state, action) => {
	switch (action.type) {
		case 'REQUEST':
			return {
				...state,
				loading: true,
				error: false,
			};
		case 'SUCCESS':
			return {
				...state,
				loading: false,
				productSelectors: action.payload,
			};
		case 'ERROR':
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};

const loadProductSelectors = (dispatch) => async () => {
	try {
		dispatch({
			type: 'REQUEST',
		});
		const response = await api.get('/productSelectors', {
			headers: {
				Authorization: `Bearer ${localStorage.getItem('token')}`,
			},
		});
		dispatch({
			type: 'SUCCESS',
			payload: response.data,
		});
	} catch (e) {
		dispatch({
			type: 'ERROR',
			payload: 'Unable to load product selectors',
		});
	}
};

export const { Context, Provider } = createDataContext(
	productSelectorsReducer,
	{
		loadProductSelectors,
	},
	{
		productSelectors: [],
		error: '',
		loading: false,
	}
);
